export function modal() {
  const body = document.querySelector('body');
  const modal = document.querySelector('.js-modal');
  const modalTrigger = document.querySelectorAll('.js-modalTrigger');
  const triggerList = Array.prototype.slice.call(modalTrigger, 0);
  const modalOverlay = document.querySelector('.js-modalOverlay');
  const modalClose = document.querySelector('.js-modalClose');

  // control
  //iframeで表示しているwindowオブジェクトを取得
  const targetWindow = document.getElementById('modalMovie').contentWindow;

  //APIのコマンドを送信する関数
  const ag2ytControl = function (action, arg = null) {
    targetWindow.postMessage('{"event":"command", "func":"' + action + '", "args":' + arg + '}', '*');
  };

  /** modal open */
  triggerList.forEach((targetBox) => {
    targetBox.addEventListener('click', () => {
      body.classList.add('is-fixed');
      modalOverlay.classList.add('is-active');
      modal.classList.add('is-active');
    });
  });

  /** modal close */
  modalClose.addEventListener('click', () => {
    body.classList.remove('is-fixed');
    modalOverlay.classList.remove('is-active');
    modal.classList.remove('is-active');
    ag2ytControl('pauseVideo');
  });

  modalOverlay.addEventListener('click', () => {
    body.classList.remove('is-fixed');
    modalOverlay.classList.remove('is-active');
    modal.classList.remove('is-active');
    ag2ytControl('pauseVideo');
  });
}
